<!-- @format -->

@if (control) {
  <div class="row local-date-range-editor">
    <div class="col-5 local-date-range-editor__first-input">
      @if (!hideLabels) {
        <label [class]="getLabelStateFor(startDate)" translate>SIS_COMPONENTS.DATE.LOCAL_DATE_RANGE_EDITOR.START_DATE</label>
      }
      <sis-local-date-editor
        [name]="name ? name + '_startDate' : 'startDate'"
        [control]="startDate"
        [datepickerPlacement]="datepickerPlacementStartDate"
        [showLabelIcon]="showLabelIcons"
        data-cy="start-date-editor"></sis-local-date-editor>
    </div>
    <span class="date-range-gutter"></span>
    <div class="col-5">
      @if (!hideLabels && !endNotRequired) {
        <label [class]="getLabelStateFor(endDate)" translate>SIS_COMPONENTS.DATE.LOCAL_DATE_RANGE_EDITOR.END_DATE</label>
      }
      @if (!hideLabels && endNotRequired) {
        <label translate>SIS_COMPONENTS.DATE.LOCAL_DATE_RANGE_EDITOR.END_DATE</label>
      }
      <div class="inner-addon">
        <sis-local-date-editor
          [name]="name ? name + '_endDate' : 'endDate'"
          [control]="endDate"
          [minDate]="minDateValue"
          [startDate]="endDateStartDate"
          [datepickerPlacement]="datepickerPlacementEndDate"
          [showLabelIcon]="showLabelIcons"
          data-cy="end-date-editor"></sis-local-date-editor>
      </div>
    </div>
  </div>
  <sis-validation-errors [control]="control"></sis-validation-errors>
}
